// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__C3mJK"};